export default {
  label: '技术总监',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '多团队或部门的技术负责人。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '组建研发部门，制定技术战略，管理平台研发，协调各部门资源。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备高级的技术视野和管理能力，能够制定技术愿景，推动技术创新。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在15年以上经验后晋升为CTO。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在50,000-100,000元之间，年薪可达100-200万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};